/* eslint-disable @typescript-eslint/camelcase */
import { Component } from 'vue-property-decorator'
import { FormBaseMixin } from './FormBaseMixin'
import { SecuritiesDealing } from '@core/model/recruit/forms/SecuritiesDealing'
@Component
export class SecuritiesDealingFormMixin extends FormBaseMixin {
  protected type = SecuritiesDealing

  get companyShortName () {
    return this.projectInfo.companyShortName
  }

  get companyLongName () {
    return this.projectInfo.companyLongName
  }

  get agreeErrMsg () {
    return this.formDataErrors?.find(err => err.key === 'agree')?.msg
  }
}
